import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';

// Directives
import { BeaconTrackDirective } from './directives/beacon-track.directive';
import { LinkifyPipe } from './pipes/linkify.pipe';
import { SafeHtmlPipe } from './pipes/safehtml.pipe';
import { DateAgoPipe } from './pipes/dateago.pipe';
import { BackBeaconService } from './services/back-beacon.service';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule
  ],
  declarations: [
    BeaconTrackDirective,

    LinkifyPipe,
    SafeHtmlPipe,
    DateAgoPipe
  ],
  entryComponents: [],
  exports: [
    BeaconTrackDirective,

    LinkifyPipe,
    SafeHtmlPipe,
    DateAgoPipe
  ],
  providers: [
    BackBeaconService
  ]
})
export class SharedModule {

}
